import { Component, Input, OnInit, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { AuditFieldworkStepDataService } from "@app/audit/services/audit-fieldworkstep-data.service";
import { AuditFieldworkStepDetailModel } from "@app/audit/shared/data-models/audit-fieldwork-step-detail-model";
import { AuditFieldworkPermissionModel } from "@app/audit/shared/permission-models/audit-fieldwork-permission-model";
import { FormValidationHelper } from "@app/shared/helpers/form-validation-helper";
import { StandingDataItemWithColor } from "@models/standingdata/StandingDataItemWithColor";
import { Observable } from "rxjs";
import { AuditFieldworkStepCommentsComponent } from "../audit-fieldwork-step-comment/audit-fieldwork-step-comments.component";
import { AuditFieldworkStepExecutionWorkingMethodComponent } from "../audit-fieldwork-step-execution-working-method/audit-fieldwork-step-execution-working-method.component";
import { CerrixTextAreaComponent } from "@app/shared/components/cerrix-textinput/cerrix-textarea/cerrix-textarea.component";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { CerrixSelectComponent } from "@app/shared/cerrix-select/cerrix-select.component";

@Component({
    selector: "audit-fieldwork-step-detail-main",
    templateUrl: "./audit-fieldwork-step-detail-main.component.html",
    styleUrls: ["./audit-fieldwork-step-detail-main.component.scss"],
    imports: [
        ReactiveFormsModule,
        AuditFieldworkStepCommentsComponent,
        AuditFieldworkStepExecutionWorkingMethodComponent,
        CerrixTextAreaComponent,
        DateInputComponent,
        CerrixSelectComponent,
    ],
})
export class AuditFieldworkStepDetailMainComponent implements OnInit {
    private _ds = inject(AuditFieldworkStepDataService);

    @Input() auditGuid: string;
    @Input() permissions: AuditFieldworkPermissionModel;
    @Input() stepModel: AuditFieldworkStepDetailModel;

    formGroup: FormGroup;
    scores: Observable<StandingDataItemWithColor[]>;

    async ngOnInit() {
        this.scores = this._ds.getAuditObservationScores(
            this.auditGuid,
            this.stepModel.observationScore
        );
        this.createFormGroup();
    }

    private createFormGroup() {
        this.formGroup = new FormGroup<any>({
            description: new FormControl({
                value: this.stepModel.description,
                disabled: true,
            }),
            observation: new FormControl(this.stepModel.observation),
            observationScore: new FormControl(this.stepModel.observationScore),
            observationDate: new FormControl(this.stepModel.observationDate),
        });

        if (!this.permissions.canEditObservation) {
            this.formGroup.disable();
        } else {
            this.formGroup.valueChanges.subscribe(() => {
                FormValidationHelper.mapToModel(this.formGroup, this.stepModel);
            });
        }
    }
}
